<template>
  <div>
    <div
      class="split-section d-flex flex-wrap login-page"
      v-if="(invalidLink == false) && (resetSuccess == false)"
    >
      <info></info>
      <div
        class="right-infosec d-flex align-items-center text-center flex-wrap justify-content-center"
      >
        <div class="signup-form">
          <div class="gr-form">
            <h2>Reset Password</h2>
            <form @submit="resetPassword" name="resetPasswordForm">
              <div
                class="alert alert-danger alert-dismissible"
                role="alert"
                v-if="showAlertMessage"
              >
                {{apiErrorMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                />
              </div>
              <div class="form-group">
                <label for="password" class="password">Password</label>
                <input
                  :type="passwordFieldType"
                  class="form-control"
                  id="password"
                  v-model="password"
                  name="password"
                  v-validate="'required|passwordFormat'"
                  ref="password"
                />
                <span
                  toggle="#password"
                  :class="passwordShowIcon"
                  @click="switchPasswordVisibility"
                ></span>
                <span class="invalid-feedback">{{ errors.first('password') }}</span>
              </div>
              <div class="form-group">
                <label for="password" class="repeat-password">Repeat password</label>
                <input
                  :type="repeatPasswordFieldType"
                  class="form-control"
                  id="repeat-password"
                  name="repeatPassword"
                  v-model="repeatPassword"
                  v-validate="'required|confirmed:password'"
                />
                <span
                  toggle="#repeat-password"
                  :class="repeatPasswordShowIcon"
                  @click="switchRepeatPasswordVisibility"
                ></span>
                <span class="invalid-feedback">{{ errors.first('repeatPassword') }}</span>
              </div>
              <div>
                <button type="submit" class="btn btn-primary">Reset</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="split-section d-flex align-items-center flex-wrap info-bg" v-else>
      <div
        class="left-infosec d-flex align-items-center flex-wrap align-items-center justify-content-center text-center rsvp"
      >
        <div class="leftblock-wrap">
          <div class="info-detail">
            <h2 v-if="invalidLink">{{message}}</h2>
            <h2 v-else>{{message}}</h2>
          </div>
          <div class="info-detail">
           
          </div>
          <div class="store-link">
            <img src="assets/images/appstore.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import Info from "./Info";

export default {
  components: {
    info: Info
  },
  data() {
    return {
      password: "",
      repeatPassword: "",
      resetSuccess: false,
      invalidLink: false,
      token: this.$route.query.token,
      message: "",
      validationMessage: "",
      passwordFieldType: "password",
      repeatPasswordFieldType: "password",
      passwordShowIcon: "fa fa-fw fa-eye field-icon toggle-password",
      repeatPasswordShowIcon: "fa fa-fw fa-eye field-icon toggle-password"
    };
  },
  mounted: function() {
    axios
      .post(
        process.env.VUE_APP_BASE_API_URL + "/auth/resetPassword/" + this.token,
        {}
      )
      .then(response => {
        this.message = response.data.message;
        if (response.status == 200) {
          this.resetSuccess = true;
        } else {
          this.invalidLink = true;
        }
      })
      .catch(error => console.log(error.message));
  },
  created() {
    this.$validator.extend("passwordFormat", {
      getMessage: () =>
        "Password must contain at least one uppercase, lowercase, digit and 8 characters long",
      validate: value =>
        value.match(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])[A-Za-z\d@$!%*#?&]{8,}$/
        ) !== null
    });
  },

  methods: {
    resetPassword(e) {
      e.preventDefault();
      const body = {
        password: this.password,
        cpassword: this.repeatPassword
      };
      this.$validator.validateAll().then(valid => {
        if (valid) {
          axios
            .post(
              process.env.VUE_APP_BASE_API_URL +
                "/auth/resetPassword/" +
                this.token,
              {
                password: body.password
              }
            )
            .then(response => {
              this.message = response.data.message;
              if (response.status == 200) {
                this.resetSuccess = true;
              } else {
                this.invalidLink = true;
              }
              //router.push({name:'ResetPasswordSuccess'})
            })
            .catch(error => console.log(error.message));
        }
      });
    },

    switchPasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordShowIcon =
        this.passwordShowIcon === "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    },

    switchRepeatPasswordVisibility() {
      this.repeatPasswordFieldType =
        this.repeatPasswordFieldType === "password" ? "text" : "password";
      this.repeatPasswordShowIcon =
        this.repeatPasswordShowIcon ===
        "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    }
  }
};
</script>
<style scoped>
.signup-form {
  margin-bottom: 75px;
}
</style>
